import {useRouter} from 'next/router';
import {useEffect, useMemo} from 'react';
import debounce from 'lodash.debounce';

export function useSyncQueryParamToLocalStorage(queryKey: string, delay = 300) {
    const router = useRouter();

    const saveToStorage = useMemo(
        () =>
            debounce((value: string[]) => {
                localStorage.setItem(queryKey, JSON.stringify(value));
            }, delay),
        [queryKey, delay]
    );

    useEffect(() => {
        if (!router.isReady) return;

        const value = router.query[queryKey];
        if (!value) return;

        const normalized = Array.isArray(value) ? value : [value];

        saveToStorage(normalized);
    }, [queryKey, router.isReady, router.query, saveToStorage]);

    useEffect(() => {
        return () => {
            saveToStorage.cancel();
        };
    }, [saveToStorage]);
}

export function getStoredUrlParm(queryKey: string): string[] {
    if (typeof window === 'undefined') return [];
    const value = localStorage.getItem(queryKey);
    try {
        return value ? JSON.parse(value) : [];
    } catch {
        return [];
    }
}
